import { useContext } from "react";

import { languages } from "src/Translations";
import { LanguageContext } from "../languageContext";
import { Button } from "./button";
import t from "src/lib/translations.json";

export const LanguagePicker = () => {
  const { language, setLanguage } = useContext(LanguageContext);

  return (
    <div className="flex gap-2">
      {languages.map((lang) => {
        return (
          <Button
            key={lang}
            className="rounded-md"
            onClick={() => setLanguage(lang)}
            variant={language === lang ? "default" : "outline"}
          >
            {t.languages[lang]}
          </Button>
        );
      })}
    </div>
  );
};
